import { DataTableColumnHeader } from 'components/ui/DataTable';
// import { DataTableActions } from 'components/ui/DataTableActions';
import { ColumnDef } from '@tanstack/react-table';
import { InvoiceStatusIcon } from '../StatusIcon';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export function useColumns() {
  let columns: ColumnDef<any>[] = [];

  columns.push(
    {
      id: 'id',
      accessorKey: 'id',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="ID" />
      ),
      enableSorting: true,
      enableHiding: false,
    },
    // {
    //   id: 'wmsId',
    //   accessorKey: 'wmsId',
    //   header: ({ column }) => (
    //     <DataTableColumnHeader column={column} title="WMS Id" />
    //   ),
    //   enableSorting: true,
    //   enableHiding: true,
    // },
    {
      id: 'data',
      accessorKey: 'scheduledAt',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Data" />
      ),
      cell: ({ row }) => {
        const date = new Date(row.original.scheduledAt);
        return format(date, 'dd/MM/yyyy HH:mm', { locale: ptBR });
      },
      enableSorting: true,
      enableHiding: true,
    },
    {
      id: 'doca',
      accessorKey: 'dock.name',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Doca" />
      ),
      enableSorting: true,
      enableHiding: true,
    },
    {
      id: 'veiculo',
      accessorKey: 'vehicleType.name',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Veículo" />
      ),
      enableSorting: true,
      enableHiding: true,
    },
    {
      id: 'placaVeiculo',
      accessorKey: 'vehiclePlate',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Placa" />
      ),
      enableSorting: true,
      enableHiding: true,
    },
    {
      id: 'transportadora',
      accessorKey: 'carrier.tradeName',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Transportadora" />
      ),
      enableSorting: true,
      enableHiding: true,
    },
    {
      id: 'cliente',
      accessorKey: 'cliente',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Cliente" />
      ),
      cell: ({ row }) => {
        return row.original.company?.tradeName;
      },
      enableSorting: true,
      enableHiding: true,
    },
    {
      id: 'tipo',
      accessorKey: 'orderType.name',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Tipo" />
      ),
      enableSorting: true,
      enableHiding: true,
    },
    {
      id: 'motivo',
      accessorKey: 'cancelationReason.name',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Motivo" />
      ),
      enableSorting: true,
      enableHiding: true,
    },
    {
      id: 'Status',
      accessorKey: 'status',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="" />
      ),
      cell: ({ row }) => {
        return <InvoiceStatusIcon status={row.original.status} />;
      },
      enableSorting: false,
      enableHiding: false,
    }
  );

  return { columns };
}
